import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import {
  clearOrderTableNumber,
  deleteAllOrderItems,
  deleteOrderForEditDetails,
} from "@redux"
import classes from "./FoodSidebarBottomBar.module.scss"

const FoodSidebarBottomBar = () => {
  const [t] = useTranslation()

  const dispatch = useDispatch()

  const orderForEditDetails =
    useSelector(state => state.orderForEditDetails)

  const handleClearCombineOrder = () => {
    dispatch(
      deleteAllOrderItems()
    )

    dispatch(
      deleteOrderForEditDetails()
    )

    dispatch(
      clearOrderTableNumber()
    )
  }

  if (orderForEditDetails !== null) {
    return (
      <div className={classes["row"]}>
        <span className={classes["code"]}>
          {t("شماره_سفارش")}:{" "}
          <b className={classes["bold"]}>
            {orderForEditDetails.orderCode}
          </b>
        </span>
        <button
          className={classes["button"]}
          onClick={handleClearCombineOrder}
        >
          {t("لغو_ویرایش")}
        </button>
      </div>
    )
  }

  return null
}

export default React.memo(FoodSidebarBottomBar)